import ThemeProvider from "./theme";
import { CssBaseline } from "@mui/material";
import MotionLazy from "./components/animate/motion-lazy";
import Router from "./routes/sections";
import { SettingsProvider } from "./components/settings";
import { Provider } from "react-redux";
import { store } from "./store/store";
// import ProgressBar from './components/progress-bar';
import "./App.css";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { SnackbarProvider } from "notistack";
function App() {
  return (
    <Provider store={store}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <SettingsProvider
          defaultSettings={{
            themeMode: "dark", // 'light' | 'dark'
            themeDirection: "ltr", //  'rtl' | 'ltr'
            themeContrast: "default", // 'default' | 'bold'
            themeLayout: "vertical", // 'vertical' | 'horizontal' | 'mini'
            themeColorPresets: "default", // 'default' | 'cyan' | 'purple' | 'blue' | 'orange' | 'red'
            themeStretch: false,
          }}
        >
          <SnackbarProvider
            autoHideDuration={2000}
            anchorOrigin={{ horizontal: "right", vertical: "top" }}
          >
            <ThemeProvider>
              <CssBaseline>
                <MotionLazy>
                  <Router />
                </MotionLazy>
              </CssBaseline>
            </ThemeProvider>
          </SnackbarProvider>
        </SettingsProvider>
      </LocalizationProvider>
    </Provider>
  );
}

export default App;
